import PropTypes from 'prop-types';
import React from 'react';
import en from '../../../international/translations/en';
import { amountToFixed } from '../../../utils/getPlanSubHeadingUtils';
import { format } from 'date-fns';
import brandToString from '../../../utils/brandToString';

const OfferConfirmation = ({ upcomingInvoice, user }) => {
  const text = en.cancellation_funnel.offer_confirmation;
  const { amountDue, plan } = upcomingInvoice;
  const date = format(new Date(), 'M/DD/YYYY');
  const chargeAmount = amountToFixed(amountDue);
  const renewalAmount = amountToFixed(plan.amount);

  return (
    <div className="offer-confirmation">
      <div className="offer-confirmation__title">{text.title}</div>
      <div className="offer-confirmation__charge">
        {text.charge(chargeAmount, date)}
      </div>
      <div className="offer-confirmation__renewal">
        {text.renewal(brandToString(), renewalAmount, plan.interval)}
      </div>
      <div className="offer-confirmation__email-notification">
        {text.notification(user.email)}
      </div>
      <a href="/" className="button-link offer-confirmation__button">
        {text.buttonText(brandToString())}
      </a>
    </div>
  );
};

OfferConfirmation.propTypes = {
  upcomingInvoice: PropTypes.shape({}).isRequired,
  user: PropTypes.shape({}).isRequired,
};

export default OfferConfirmation;
